

const reviews = [
    {
      id: 1,
      name: 'Susan Smith',
      image:
        'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883334/person-1_rfzshl.jpg',
      text:
        'Thanks to Galleon, I can manage my budget much more easily ...'
    },
    {
      id: 2,
      name: 'Anna Johnson',
      image:
        'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883409/person-2_np9x5l.jpg',
      text:
        'The Galleon is so easy to use that even my son manages his pocket money with Galleon.',
    },
    {
      id: 3,
      name: 'Peter Jones',
      image:
        'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883417/person-3_ipa0mj.jpg',
      text:
        'Thanks to Galleon, I no longer have to live paycheck to paycheck.',
    },
    {
      id: 4,
      name: 'Bill Anderson',
      image:
        'https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883423/person-4_t9nxjt.jpg',
      text:
        'Galleon saved my life. Thanks to him, I am debt-free now.'
    },
  ];
  
  export default reviews;